module.exports = __webpack_public_path__ + "img/category-title04.f19fd445.png";